import { atom } from 'recoil'

export const userAtom = atom({ key: 'userAtom', default: undefined })

export const biltyOpsAtom = atom({ key: 'biltyOpsAtom', default: [] })
export const vicinitiesAtom = atom({ key: 'vicinitiesAtom', default: [] })
export const trackersAtom = atom({ key: 'trackersAtom', default: [] })
export const userTypesAtom = atom({ key: 'userTypesAtom', default: [] })

export const importOrdersAtom = atom({ key: 'importOrdersAtom', default: [] })
export const exportOrdersAtom = atom({ key: 'exportOrdersAtom', default: [] })
export const bulkOrdersAtom = atom({ key: 'bulkOrdersAtom', default: [] })
export const searchOrdersAtom = atom({ key: 'searchOrdersAtom', default: [] })

export const importJobsAtom = atom({ key: 'importJobsAtom', default: [] })
export const exportJobsAtom = atom({ key: 'exportJobsAtom', default: [] })
export const bulkJobsAtom = atom({ key: 'bulkJobsAtom', default: [] })

export const trackerJobAtom = atom({ key: 'trackerJobAtom', default: [] })
